import React from 'react'
import './FooterSec1.css'

function FooterSec1() {
  return (
    <section className='footer-sec-1'>
      <div className='container'>
        <div className='footer-sec-1-content'>
          <div className='footer-sec-1-text'>
          <h3>Request A Free Consultation</h3>
          <p>the quick fox jumps over the lazy dog</p>
          </div>
          <button className='footer-sec-1-btn'>Contact Us</button>
        </div>
      </div>
    </section>
  )
}

export default FooterSec1